
jQuery(document).ready(function() {

//clear the input fields
    jQuery
	(".clear-me").on('click focusin', function() {
         this.value = '';
     });
	 
	 
 //mobile stuff
	
       /**
      * Clicked somewhere other than the nav
      * So, close the nav.
      *
      * @memberof DocumentReady
      *
      * @function hideMobileNav
      *
      * @listens click
      */
     jQuery('.page-overlay').click( function(){

       console.log('clicked overlay');

       jQuery('.page-overlay').hide();
       jQuery('.mobile-nav-slide').removeClass('on');
       jQuery('.mobile-nav-slide .nav-wrap > ul .close').remove();


     }); // .click('.page-overlay')



     /*
       New slide in mobile menu

      */
     jQuery('.mobile-nav-fixed li.menu-item-140').on('click', 'a', function(event) {

       console.log('clicked menu icon');
       event.preventDefault();


       jQuery('.mobile-nav-slide').toggleClass('on').promise().done(function(){

         //console.log( jQuery('.mobile-nav-slide').attr('class') );
    
         if ( jQuery('.mobile-nav-slide').hasClass('on') ) {

           jQuery('.page-overlay').show();
           //add close button
           jQuery('.mobile-nav-slide .nav-wrap > ul').append('<li class="close"></li>');

         }

       });

     });


   //close slide menu
   jQuery('.mobile-nav-slide .nav-wrap > ul').on('click', '.close', function(){

     console.log('clicked X icon');
     jQuery('.page-overlay').trigger('click');

   });




     // Toggling second-tier in the slide out menu
     jQuery('.mobile-nav-slide .nav-wrap > ul > li.menu-item-has-children > a').click(function() {
		
 		console.log('top level clicked');
		
 		jQuery('li').removeClass('on');
 		jQuery('.mobile-nav-slide .nav-wrap ul li.menu-item-has-children ul.sub-menu').hide('fast');

 		      if ( jQuery(this).siblings('ul.sub-menu').length ) {

 		        event.preventDefault();

 				if (jQuery(this).closest('li').find('.sub-menu:first-of-type').first().is(':visible')) {
 					jQuery('li').removeClass('on');
 					jQuery('.sub-menu').hide('fast');
 				}else{

 					jQuery(this).closest('li').toggleClass('on').find('.sub-menu:first-of-type').first().slideToggle('fast');
 				};


 		      }

     }); // .menu-item-has-children
	
     jQuery('.mobile-nav-slide .nav-wrap > ul > li > ul > li.menu-item-has-children > a').click(function() {
		
 		console.log('3rd level clicked');
		
 		jQuery('ul > li').removeClass('on');
 		jQuery('.mobile-nav-slide .nav-wrap > ul > li > ul > li.menu-item-has-children ul.sub-menu').hide('fast');

 		      if ( jQuery(this).siblings('ul.sub-menu').length ) {

 		        event.preventDefault();

 				if (jQuery(this).closest('li').find('.sub-menu:first-of-type').first().is(':visible')) {
 					jQuery('ul > li').removeClass('on');
 					jQuery('.mobile-nav-slide .nav-wrap > ul > li > ul > li.menu-item-has-children ul.sub-menu').hide('fast');
 				}else{

 					jQuery(this).closest('ul > li').toggleClass('on').find('.sub-menu:first-of-type').first().slideToggle('fast');
 				};


 		      }

     }); // .menu-item-has-children 3rd level

 //end mobile nav 
	
     /* Fixed Nav - Contact Button */
     jQuery('.mobile-nav-fixed li.menu-item-142').on('click', 'a', function(event) {
		
		

       var sidebar_form = jQuery('.contact-form');
	  
	  

       if ( sidebar_form.length && sidebar_form.is(":visible") ){

 		  // alert("yes");
 		  //
 		  event.preventDefault();

         var nav_height = 70;
         scrollto_px = sidebar_form.offset().top - nav_height - 20;

         jQuery('html, body').animate({
           scrollTop: scrollto_px
         }, 'fast');
      }

     }); // .menu-item-402
  
  
  

  
  jQuery( "#cake-product-form" ).submit(function( event ) {
    
   var what_size = jQuery( "#variant-select option:selected" ).text();
    
    //console.log(what_size);

    if(what_size == "Select"){
    
    	alert('Please select a product option from the dropdown');
      
      
      event.preventDefault();
    
    }
    
   
   
   var what_quantity = jQuery( "#quantity" ).val();
    //console.log("QUANTITY: " + what_quantity);
    
        if(what_quantity == ""){
    
    	alert('Please enter a quantity');
      
      event.preventDefault();
    
    }
    

});


  
}); /* Document Ready */











function isMobile(){
  //get windows size and determine if mobile device
  //var windowsize = screen.availWidth;
  var windowsize = window.innerWidth;
  
  var isMobile = "?";
  //alert(windowsize);
  if (windowsize >= 960) {
      return false;
  } else {
      return true;
  }
}



/* [ GLOBAL Shared Functions ]------------------------------------------ */




function update_querystring_parameter(uri, key, value) {
  var re = new RegExp("([?|&])" + key + "=.*?(&|$)", "i");
  separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}


function get_url_parameter(url, name) {
    return decodeURI(
        (RegExp(name + '=' + '(.+?)(&|$)').exec(url)||[,null])[1]
    );
}


function write_cookie(name, value, days) {

  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString();
  } else{
    var expires = "";
  }
  
  document.cookie = name+"="+value+expires+"; path=/";
}


function read_cookie(key) {
  var result;
  return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? (result[1]) : null;
}


function thisHeight(){
  return jQuery(this).height();
}








/* [ GLOBAL Shared Functions ]------------------------------------------ */
/* ##################################################################### */










